import type { IBrandTemplate } from '@/types/api';
import { isDarkColor } from '.';

export function setThemeColors(data: IBrandTemplate): void {
  const root = document.documentElement;
  const primaryColor = data?.primary_color;
  const secondaryColor = data?.secondary_color;
  const textColorPrimary = isDarkColor(primaryColor);
  const textColorSecondary = isDarkColor(secondaryColor);
  root.style.setProperty('--brand-primary', primaryColor);
  root.style.setProperty('--brand-secondary', secondaryColor);
  root.style.setProperty('--brand-primary-text-color', textColorPrimary);
  root.style.setProperty('--brand-secondary-text-color', textColorSecondary);

  // root.style.setProperty('--cont-blur', blurBackground);
}
